import './assets/scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'

import router from './router'
import store from './store/index'
import Notifications from '@kyvg/vue3-notification'
import CustomVar from '@/plugins/custom'
import ModalCustom from '@/components/ModalCustom.vue'
import MultiSelect from '@/plugins/MultiSelect.vue'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import Popper from "vue3-popper";
import Vue2Editor from "vue3-editor";
import GlobalTooltip from './components/GlobalTooltip.vue'
import { createTooltipDirective } from './directives/tooltip'

import moment from 'moment';
moment.locale('ru');
import("bootstrap/js/index.esm");
import 'vue-final-modal/style.css'


let app;
app = createApp(App);
app.use(router)
app.use(Notifications).use(Vue2Editor).use(store)
app.component("modal", ModalCustom)
app.component("MultiSelect", MultiSelect)

app.component('GlobalTooltip', GlobalTooltip)
app.directive('tooltip', createTooltipDirective())

app.component('date-picker', VueDatePicker);
app.component("popper", Popper);
app.use(CustomVar)
app.config.globalProperties.$moment=moment;

app.mount('#app')
